<template>
  <f7-page>
    <b-container fluid class="main-content icon-homepage-button-request-payment">
      <b-row class="homepageTextBloc1">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <h1 class="d-block text-center text-white" style="font-size:4rem !important">
              <!-- <img width="450px" height="22%" :src="MrBgLogo" alt="mr_logo_green" /> -->
              {{ $t('Homepage.welcome_SDD') }}
            </h1>
          </transition>
        </b-col>
      </b-row>
      <transition name="slide-fade-title" appear>
        <b-row v-if="data" class="homepageCards offset-1 col-9">
          <carousel :items="nbMaxItem" class="col-12" :nav="false" :dots="true">
            <b-col v-for="button in data" :key="button.id" v-if="hasRight(button.right)" cols="12" class="d-flex flex-row justify-content-center">
              <div class="homeCardBody text-center" :class="button.class"  @click="redirect(button.link)">
                <i :class="button.icon" style="font-size:50px"></i>
                <h4>{{ $t(button.title) }}</h4>
                <b-button v-if="button.actionTitle && !flagTOOLBOX" class="btn" size="lg">
                  {{ $t(button.actionTitle) }}
                </b-button>
              </div>
            </b-col>
          </carousel>
        </b-row>
      </transition>
    </b-container>
  </f7-page>
</template>

<script>
import carousel from 'vue-owl-carousel2'
import buttonsData from '@/pages/user/data/homepageData.json'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {loadPage} from '@/helpers/routing'
import DealPrudenceLogo from '../../assets/static/images/homepage/dealprudence_texte_seul.png'
import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence
import conf from "@/config/config.dev";

export default {
  name: 'Homepage',
  components: {
    carousel
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    }
  },
  data () {
    return {
      data: [],
      backgroundImg: 'background-image: url(' + Img +')',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      design: design.menu,
      imgLogo: Logo,
      MrBgLogo: DealPrudenceLogo,
      nbButtons: 0,
      nbMaxItem: 4,
      nbMaxColor: 4,
     }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (this.hasRight(item.right)) {
        that.getCardClass
        item.class = that.getCardClass(item) + ' ' + item.class
        availableButtons.push(item)
      }
    })
    this.data = availableButtons
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }
  },
  mounted () {
  },
  methods: {
    getCardClass (button) {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    redirect (url) {
      loadPage(this, { url: url })
      this.$bus.$emit('switch-selected-menu', url)
    }
  }
}
</script>
<style scoped>
/* .card, .card-body .card-title {
  background: var(--actionButtonColorViolet);
  color: var(--actionTextColorWhite)!important;
  min-height: 300px;
} */

.homeCardBody {
  color: var(--actionTextColorWhite)!important;
  min-height: 300px;
  min-width: 270px;
  width: 270px;
  height: 300px;
  border-radius: var(--borderRadius);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content:space-around;
}

.homeCardBody h4{
  color: var(--actionTextColorWhite)!important;
}

.homeCardBody.homeCardBody-1 {
  background: linear-gradient(0.25turn,#11b1fd,#11b1fd);
}

.homeCardBody.homeCardBody-2 {
  background: linear-gradient(0.25turn,#00a76c,#00a76c)
}

.homeCardBody.homeCardBody-3 {
  background: linear-gradient(0.25turn,#ffac00,#ffac00)
}

.homeCardBody.homeCardBody-4 {
  background: linear-gradient(0.25turn,#6b6aea,#6b6aea)
}

.main-content {
  height: 100%;
  overflow-x: hidden;
}
.main-page-positionning {
  margin-top: 44px;
  margin-bottom: 44px;
}
.homepageBackgroundImage {
  background-size: cover;
}
.homepageBaseline {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageBaselineText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 1.2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageSubTitle {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageSubTitleText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 2rem;
  line-height: normal;
  color: #ffffff;
}

@media (min-width:630px) and (max-width:889px) {
  .homepageBaselineText {
    font-size: 1.5rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 4rem;
  }
}
@media (min-width:890px) and (max-width:991px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 5rem;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 6rem;
  }
}

@media (min-width:1030px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 7rem;
  }
}
@media (min-width:1200px) {
  .homepageBaselineText {
    font-size: 2.5rem;
  }
  .homepageSubTitleText {
    font-size: 2.5rem;
  }
  .homepageTitleText {
    font-size: 8rem;
  }
}

@media (min-width:992px) {
  .main-page-positionning {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media (max-width:991px) {
  .homepageTitle > img {
    width: 300px;
    height: 150px;
    object-fit: contain;
  }
  .main-content {
    height: calc(100% - 44px);
  }
}

.homepageSubTitleLogo {
  width: 200px;
  margin-right: 1rem;
}

@media (max-width:450px) {
  .homepageSubTitleLogo {
    width: 350px;
  }
}

/* .icon-homepage-button-request-payment {
  background-image: url('./../../assets/static/images/homepage/accueil.png');
} */
</style>
